/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-05 15:02:57
 * @LastEditTime: 2020-08-14 20:20:37
 * @Description: 帮助函数
 */

/**
 * @description 格式化时间
 * @param {string} dateTimeStamp 原始时间
 */
export const formatedDate = (dateTimeStamp) => {
	const timeConvert = new Date(dateTimeStamp);
	let result = "";
	const minute = 1000 * 60;
	const hour = minute * 60;
	const day = hour * 24;
	const month = day * 30;
	const now = new Date().getTime();
	const diffValue = now - timeConvert.getTime();
	if (diffValue < 0) return;
	const monthC = diffValue / month;
	const weekC = diffValue / (7 * day);
	const dayC = diffValue / day;
	const hourC = diffValue / hour;
	const minC = diffValue / minute;
	if (monthC >= 1) {
		result = "" + parseInt(monthC) + "月前";
	} else if (weekC >= 1) {
		result = "" + parseInt(weekC) + "周前";
	} else if (dayC >= 1) {
		result = "" + parseInt(dayC) + "天前";
	} else if (hourC >= 1) {
		result = "" + parseInt(hourC) + "小时前";
	} else if (minC >= 1) {
		result = "" + parseInt(minC) + "分钟前";
	} else {
		result = "刚刚";
	}

	return result;
}

/**
 * @description 对象数组去重
 * @param {array} array 需要去重的数组
 * @param {string} key 去重键值依据
 */
export const objectArrayUnique = (array, key) => {
	let ojb = {};
	array = array.reduce(function (prevArr, currentItem) {
		ojb[currentItem[key]] ? '' : ojb[currentItem[key]] = true && prevArr.push(currentItem);
		return prevArr
	}, [])
	return array;
}

/**
 * 
 * @param {array} array 原数组
 * @param {array} targetArray 目标数组
 * @returns 返回交集的数据
 */
export const arrayIntersection = (array, targetArray) => {
	return array.filter(x => {
		return targetArray.indexOf(x) > -1;
	});
};

// 转为以万为单位
export const numberToWan = (value, digit = 1) => {
	if (!value) return '-';
	return (value / 10000).toFixed(digit);
};

export const cusStatusTrans = {
	none: '无',
	dev: '开发中',
	supplying: '供货中'
};


export const fromModelToText = {
	huokuan: "客户货款",
	buzhu: "政府补助",
	tuibzj: "退保证金",
	yinhang: "银行放款",
	"gl-huokuan": "关联公司收货款",
	"gl-jiekuan": "关联公司还借款",
	"gl-others": "关联公司的其他收款",
	others: "其他",
};
export const typeToText = {
	trans: "银行转账",
	bankAccBill: "银承",
	commAccBill: "商承",
	check: "支票",
	cash: "现金钞票",
	yun: "云信通",
	jian: "建信融通",
	bankAccBillPaper: "纸质银承",
	gold: "金单",
	sywx: "商银微芯",
	ji: "集信",
	zhu: "筑信",
};
export const statusToText = {
	needConfirm: "需财务确认",
	confirmed: "已确认",
	rejected: "财务拒绝",
	cancelled: "业务员取消",
};
export const billStatusToText = {
	waiting: "未到期",
	receive: "到期兑现",
	overdue: "逾期无法兑现",
	paid: "背书给供应商",
	partPaid: "部分支付",
};
export const billTagsToText = {
	heimingdan: "黑名单",
	ketiexian: "可贴现",
	"6+9": "6+9",
};